import { ReferenceVideoSidebar } from "./ReferenceVideoSidebar";
import { VideoRemakeStudioFooter } from "./VideoRemakeStudioFooter";
import { VideoRemakeStudioForm } from "./VideoRemakeStudioForm";

export function VideoRemakeStudio() {
  return (
    <div className="flex h-full w-[1036px] shrink-0 min-h-0">
      <ReferenceVideoSidebar />
      <div className="flex h-full w-[720px] shrink-0 flex-col border-x border-kds-border bg-kds-bg">
        <div className="kds-scroll-thin min-h-0 flex-1 overflow-y-auto">
          <VideoRemakeStudioForm />
        </div>
        <VideoRemakeStudioFooter />
      </div>
    </div>
  );
}
